import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(
    public http: HttpClient
  ) {
  }

  tinhDienTich = async features => await this.http.post(`${environment.api}/tinh-dien-tich`, features).toPromise();

  tinhChieuDai = async features => await this.http.post(`${environment.api}/tinh-chieu-dai`, features).toPromise();

  searchByFields = async params => await this.http.post(`${environment.api}/search-by-fields`, params).toPromise();

  getDataByField = async params => await this.http.post(`${environment.api}/get-data-by-field`, params).toPromise();

  getDataGraph = async () => await this.http.get(`${environment.api}/get-data-graph`).toPromise();

  getItem = async params => await this.http.post(`${environment.api}/get-item`, params).toPromise();

  getExtent = async params => await this.http.post(`${environment.api}/get-extent`, params).toPromise();
}
